import Box from "../box";
import Flex from "../flex";
import Icon, { IconType } from "../icons";

export interface EmptyViewProps {
  description?: string;
  icon?: IconType;
  iconColor?: string;
}

function EmptyView({ description, icon = IconType.EmptyThin, iconColor }: EmptyViewProps): React.JSX.Element {
  return (
    <>
      <Flex flexDirection="column" alignItems="center" justifyContent="space-around" color="#d1d5db">
        <Flex flexDirection="column" alignItems="center" justifyContent="center">
          <Flex alignItems="center" justifyContent="center" mb="16px">
            <Icon width={124} height={124} name={icon} color={iconColor} />
          </Flex>
          <Box>{description}</Box>
        </Flex>
      </Flex>
    </>
  );
}

export default EmptyView;
